import '../../../domain-model';
import './cubby-properties';
import './door-properties';
import BaseProperties from './base-properties';
import CubbyProperties from './cubby-properties';
import DomainModel from '../../../domain-model';
import DoorProperties from './door-properties';
import { Cubby, Door } from '../../../domain';

const map: Map<typeof DomainModel, typeof BaseProperties> = new Map();

map.set(Cubby, CubbyProperties);
map.set(Door, DoorProperties);

export default (item: typeof DomainModel): typeof BaseProperties => {
    return map.get(item);
}
